import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
export function Guarantee() {
  return <section className="w-full bg-white px-4 py-14" data-id="element-145" data-mp="20m4opq90saty">
      <div className="mx-auto w-full max-w-xl text-center" data-id="element-146" data-mp="24mon0x5bxkho">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-50" data-id="element-147" data-mp="24l3rb47a3vi8">
          <ShieldCheckIcon className="h-8 w-8 text-emerald-600" aria-hidden="true" data-id="element-148" data-mp="29g17cv2z754m" />
        </span>
        <h2 className="mt-4 font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-149" data-mp="2ef48i4fu4r7b">
          100% Risk-Free Guarantee
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-ink-soft" data-id="element-150" data-mp="2oc8ti0xy2gmj">
          Try the Clinical Certainty Protocol™ for 7 full days. If you don’t feel more confident
          diagnosing, planning, and making decisions… we’ll give you{' '}
          <strong className="font-semibold text-ink" data-id="element-151" data-mp="tz9aryy9p6b1">100% of your money back</strong>.
        </p>
        <p className="mt-3 text-[14px] font-semibold text-emerald-700" data-id="element-152" data-mp="y0uhf2k7kocs">
          No questions. No friction.
        </p>

        <SectionCTA headline="Zero risk. Immediate clarity." data-id="element-153" data-mp="3nuq23x2jcy12" />
      </div>
    </section>;
}